// src/platform/index.ts
var ua = typeof navigator !== "undefined" && typeof navigator.userAgent === "string" ? navigator.userAgent : "";
var isMac = /Mac|iPod|iPhone|iPad/.test(ua);
var isWindows = /Win/.test(ua);
var isLinux = !isMac && !isWindows && /Linux/.test(ua);
var MOD_KEY = isMac ? "\u2318" : "Ctrl";
function formatShortcut(keys) {
  const sep = isMac ? "" : "+";
  return keys.map((k) => {
    const lc = k.toLowerCase();
    if (lc === "mod" || lc === "cmd" || lc === "meta") return MOD_KEY;
    if (lc === "ctrl") return isMac ? "\u2303" : "Ctrl";
    if (lc === "shift") return isMac ? "\u21E7" : "Shift";
    if (lc === "alt" || lc === "option") return isMac ? "\u2325" : "Alt";
    if (lc === "enter" || lc === "return") return isMac ? "\u21B5" : "Enter";
    if (lc === "esc" || lc === "escape") return "Esc";
    return k.toUpperCase();
  }).join(sep);
}

export { MOD_KEY, formatShortcut, isLinux, isMac, isWindows };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map